<div class="dxp-row dxp-bg-initial screen-padding">
    <div class="dxp-bg-initial dxp-col-md-12">
        <dxp-flex-layout>
            <dxp-flex-layout-item slot="column-1" column-width-sm="12" column-width-lg="12" padding-style-sm="10px 15px 20px 0px">
                <p class="dxp-pt-7 feature-title">Review requests</p>
                <p class="action-message-14px">{{msg.MakerChecker.HeaderNote}}</p>
            </dxp-flex-layout-item>
        </dxp-flex-layout>
    </div>
    <div id="mc-panels" class="dxp-bg-initial dxp-col-md-12">
        <maker-checker-search-panel id="mc-left-panel" class="dxp-col-md-3" (requestEmitter)="this.selectedRequest($event)"></maker-checker-search-panel>
        <maker-checker-request-details-panel id="mc-details-panel" class="dxp-col-md-9" (reloadRequest)="this.reloadRequests($event)" [requestDetail]="this.requestDetail"></maker-checker-request-details-panel>
    </div>
</div>
